// Bump this string on every release so the admin footer can confirm the live frontend build.
export const APP_BUILD = "2026.06.09-inline-default";
